import { GuardedType, isSingletonStringUnion, isString } from "generic-type-guard";

import { createDescriptorFunctions } from "@de.skhh.modulf/client-core";

export const ArchiveModuleFormDescriptor = createDescriptorFunctions(
	{
		modal: "archive",
		engine: "form"
	} as const,
	{
		sourceActivityId: isString,
		archiveLocation: isString,
		archiveSystem: isSingletonStringUnion("eldorado", "xakte"),
		instance: isString
	}
);

export type ArchiveModuleFormDescriptor = GuardedType<typeof ArchiveModuleFormDescriptor.isInstance>;
